<div class="col-md-12">
  <h3 class="">Report - Aging</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />

<div class="panel panel-primary">
  <div class="panel-heading">Search Information</div>
  <div class="panel-body">
  <div class="form">
    <div class="form-group row">
      <label for="SupplierNamelbl" class="col-sm-2 col-form-label">Supplier Name:</label>
      <div class="col-sm-4">
        <input placeholder="All" name="SupplierNamelbl" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier"/>
</div>

    </div>

    <div class="form-group row">
      <label for="ObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
      <div class="col-sm-4">
        <input placeholder="All" name="ObjectAccountlbl" id="ObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"/>
      </div>
    </div>
    <div class="form-group row">
      <label for="dpAppr" class="col-sm-2 col-form-label">Compliance Approved Date:</label>
         <div class="col-sm-3">
          <input class="form-control" 
          name="dpAppr" id="dpAppr" [(ngModel)]="ApprDt" ngbDatepicker #dt="ngbDatepicker"  [disabled]="user.Role!='Admin'"> 
        </div>
         <div class="col-sm-1" style="padding-left: 0px;">
            <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button"  [disabled]="user.Role!='Admin'"></button>
         </div>
         
  </div>
    <div class="form-group row">
      <div class="col-sm-2 col-form-label"></div>
      <div class="col-sm-4">
        <button class="btn btn-primary"  (click)="search()" >Search</button>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  <div #TABLE #table>
  <table class="table table-bordered" *ngIf="AgingResult.length > 0" id="reportGrid_all">
    <thead>
      <tr >
          <th *ngFor = 'let key of keys'>{{key}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor = 'let item of AgingResult'>
        <td *ngFor = 'let key of keys'>{{item[key]}}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="form-group row" *ngIf="AgingResult.length > 0">
  <div class="col-sm-4">
    <button (click)="ExportTOExcel()"  class="btn btn-primary">ExportTOExcel</button>
  </div>
</div>  
<br>
<div *ngIf="AgingResult.length > 0" style="display: block">
  <google-chart #chart  
  [title]="title"  
  [type]="type"  
  [data]="graphData"  
  [columnNames]="columnNames"  
  [options]="options"  
  [width]="width"  
  [height]="height">  
  </google-chart>
</div>
  
